import { Accordion, Tabs } from 'flowbite';

document.addEventListener('DOMContentLoaded', function ()
{

/*
    const accordionElement = document.getElementById('accordion-atributos');

    // create an array of objects with the id, trigger element (eg. button), and the content element
    const accordionItems = [
        {
            id: 'accordion-garantias-heading',
            triggerEl: document.querySelector('#accordion-garantias-heading'),
            targetEl: document.querySelector('#accordion-garantias-body'),
            active: true
        },
        {
            id: 'accordion-procedimiento-heading',
            triggerEl: document.querySelector('#accordion-procedimiento-heading'),
            targetEl: document.querySelector('#accordion-procedimiento-body'),
            active: false
        },
        {
            id: 'accordion-contribuciones-heading',
            triggerEl: document.querySelector('#accordion-contribuciones-heading'),
            targetEl: document.querySelector('#accordion-contribuciones-body'),
            active: false
        },
        {
            id: 'accordion-exclusiones-heading',
            triggerEl: document.querySelector('#accordion-exclusiones-heading'),
            targetEl: document.querySelector('#accordion-exclusiones-body'),
            active: false
        },
        {
            id: 'accordion-emergencias-heading',
            triggerEl: document.querySelector('#accordion-emergencias-heading'),
            targetEl: document.querySelector('#accordion-emergencias-body'),
            active: false
        }
    ];
*/


    const accordionElement = document.getElementById('accordion-atributos');
    const itemEls = accordionElement.querySelectorAll('.accordion-item');

    const accordionItems = Array.from(itemEls).map(item => {
        const id = item.dataset.accordionId;
        return {
            id: `accordion-${id}-heading`,
            triggerEl: document.querySelector(`#accordion-${id}-trigger`),
            targetEl: document.querySelector(`#accordion-${id}-body`),
            active: item.dataset.accordionActive === 'true'
        };
    });

    // options with default values
    const options = {
        alwaysOpen: false, // Solo un acordeón abierto a la vez
        activeClasses: 'accordion-active',
        inactiveClasses: 'accordion',
        onOpen: (item) => {
            console.log('accordion item has been shown');
            console.log(item);
        },
        onClose: (item) => {
            console.log('accordion item has been hidden');
            console.log(item);
        },
        onToggle: (item) => {
            console.log('accordion item has been toggled');
            console.log(item);
        },
    };


    // instance options object
    const instanceOptions = {
        id: 'accordion-atributos',
        override: true
    };

    const accordion = new Accordion(accordionElement, accordionItems, options, instanceOptions);


});
